import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from "../Footer";
import axios from "axios";
import DataTable from "react-data-table-component";
import { SkeletonTable } from "../components/SkeletonLoader";
import { BtnLoader } from "../components/PageLoader";
import { toTitleCase } from "../helper/formatCarName";

const AllMyCars = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);

  function formatEuroAmount(amount) {
    if (!amount && amount !== 0) return "—";
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  const getAllMyCar = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/cars/all-mylist",
        {
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    getAllMyCar();
  }, []);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const handleSelectedRowsChange = ({ selectedRows }) => {
    const ids = selectedRows.map((row) => row.id);
    setSelectedRowIds(ids);
  };
  const publishMyCars = async () => {
    try {
      setLoading2(true);
      const response = await axios.post(
        window.CARLOCA_API + "/car/publish-and-unpublish",
        {
          car_ids: selectedRowIds,
          status: 1,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        setLoading2(false);
        getAllMyCar();
      } else {
        setLoading2(false);
        alert(response?.data?.message);
      }
    } catch (error) {
      setLoading2(false);
      console.log("An error occurred while fetching data.", error);
    }
  };
  const unpublishMyCars = async () => {
    try {
      setLoading1(true);
      const response = await axios.post(
        window.CARLOCA_API + "/car/publish-and-unpublish",
        {
          car_ids: selectedRowIds,
          status: 0,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        setLoading1(false);
        getAllMyCar();
      } else {
        setLoading1(false);
        alert(response?.data?.message);
      }
    } catch (error) {
      setLoading1(false);
      console.log("An error occurred while fetching data.", error);
    }
  };

  const columnsData = [
    {
      name: "Vehicle",
      minWidth: "220px",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "6px 0" }}>
          <img
            src={
              row.image
                ? `${window.CARLOCA_UPLOADS}/cars/${row.image}`
                : "img/noimg.jpeg"
            }
            alt={row.make}
            style={{
              width: "48px",
              height: "36px",
              borderRadius: "6px",
              objectFit: "cover",
              border: "1px solid #e8ecf0",
              flexShrink: 0,
            }}
          />
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontWeight: 600, color: "#1a1a2e", fontSize: "13px", textTransform: "capitalize" }}>
              {toTitleCase(row.make)} {toTitleCase(row.model)}
            </div>
            <div style={{ fontSize: "11px", color: "#8b95a5" }}>
              {row.year} · {row.body_type || "—"}
            </div>
          </div>
        </div>
      ),
      sortable: true,
      sortFunction: (a, b) => {
        const nameA = `${a.make} ${a.model}`.toLowerCase();
        const nameB = `${b.make} ${b.model}`.toLowerCase();
        return nameA.localeCompare(nameB);
      },
    },
    {
      name: "Colour",
      selector: (row) => row.color,
      cell: (row) => (
        <span style={{ textTransform: "capitalize", fontSize: "13px", color: "#444" }}>
          {row.color || "—"}
        </span>
      ),
      width: "90px",
    },
    {
      name: "Price",
      cell: (row) => (
        <span style={{ fontWeight: 700, color: "#00889c", fontSize: "13px" }}>
          £{formatEuroAmount(row.offer_price)}
        </span>
      ),
      sortable: true,
      sortFunction: (a, b) => (a.offer_price || 0) - (b.offer_price || 0),
      width: "110px",
    },
    {
      name: "Added",
      selector: (row) => row.created_date,
      cell: (row) => (
        <span style={{ fontSize: "12px", color: "#6b7280" }}>
          {row.created_date || "—"}
        </span>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: ".3px",
            background: row.status === 1 ? "rgba(16,185,129,0.1)" : "rgba(239,68,68,0.1)",
            color: row.status === 1 ? "#059669" : "#dc2626",
            border: `1px solid ${row.status === 1 ? "rgba(16,185,129,0.2)" : "rgba(239,68,68,0.2)"}`,
          }}
        >
          <span style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            background: row.status === 1 ? "#10b981" : "#ef4444",
            flexShrink: 0,
          }}></span>
          {row.status === 1 ? "Live" : "Draft"}
        </span>
      ),
      width: "95px",
      center: true,
    },
    {
      name: "Preview",
      cell: (row) => (
        <Link
          to={
            row.status === 1
              ? `/cardetails?car=${row?.slug}`
              : `/dealer/saved/car/detail?car=${row?.slug}`
          }
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 10px",
            borderRadius: "6px",
            fontSize: "11px",
            fontWeight: 600,
            color: "#00889c",
            border: "1px solid #00889c",
            background: "transparent",
            textDecoration: "none",
            transition: "all .2s",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => { e.target.style.background = "#00889c"; e.target.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.target.style.background = "transparent"; e.target.style.color = "#00889c"; }}
        >
          <i className="fa-solid fa-eye" style={{ fontSize: "10px" }}></i> View
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "85px",
      center: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "4px" }}>
          <button
            onClick={() => editMyCar(row?.id)}
            type="button"
            title="Edit"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              height: "30px",
              borderRadius: "6px",
              border: "1px solid #e0e5ed",
              background: "#fff",
              cursor: "pointer",
              transition: "all .2s",
              color: "#00889c",
              fontSize: "13px",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#00889c"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#00889c"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#00889c"; e.currentTarget.style.borderColor = "#e0e5ed"; }}
          >
            <i className="fa fa-edit"></i>
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            type="button"
            title="Delete"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              height: "30px",
              borderRadius: "6px",
              border: "1px solid #fde8e8",
              background: "#fff",
              cursor: "pointer",
              transition: "all .2s",
              color: "#ef4444",
              fontSize: "13px",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#ef4444"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#ef4444"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#ef4444"; e.currentTarget.style.borderColor = "#fde8e8"; }}
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      ),
      width: "85px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];

  const [filterText, setFilterText] = useState("");

  const filteredItems = data.filter(
    (item) =>
      (item.make &&
        item.make.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.model &&
        item.model.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.body_type &&
        item.body_type.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.color &&
        item.color.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.year &&
        String(item.year).toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponent = (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", width: "100%", flexWrap: "wrap", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#6b7280", fontSize: "13px" }}>
        <span style={{ fontWeight: 600, color: "#1a1a2e" }}>{filteredItems.length}</span> vehicles
        {selectedRowIds.length > 0 && (
          <span style={{ background: "rgba(0,136,156,0.1)", color: "#00889c", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: 600 }}>
            {selectedRowIds.length} selected
          </span>
        )}
      </div>
      <div style={{ position: "relative", minWidth: "200px", maxWidth: "280px" }}>
        <i className="fa-solid fa-magnifying-glass" style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: "12px" }}></i>
        <input
          type="text"
          placeholder="Search make, model, year..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 12px 8px 32px",
            borderRadius: "8px",
            border: "1.5px solid #e5e7eb",
            fontSize: "13px",
            fontFamily: "'Poppins', sans-serif",
            color: "#333",
            outline: "none",
            transition: "border-color .2s, box-shadow .2s",
            background: "#fafbfc",
          }}
          onFocus={(e) => { e.target.style.borderColor = "#00889c"; e.target.style.boxShadow = "0 0 0 3px rgba(0,136,156,0.1)"; }}
          onBlur={(e) => { e.target.style.borderColor = "#e5e7eb"; e.target.style.boxShadow = "none"; }}
        />
      </div>
    </div>
  );

  const tableCustomStyles = {
    table: {
      style: {
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #f0f3f5",
      },
    },
    headRow: {
      style: {
        background: "linear-gradient(135deg, #f8fafb 0%, #f0f4f5 100%)",
        borderBottom: "2px solid #e8ecf0",
        minHeight: "48px",
        fontSize: "11.5px",
        fontWeight: 700,
        color: "#5f6b7a",
        textTransform: "uppercase",
        letterSpacing: ".5px",
        fontFamily: "'Poppins', sans-serif",
      },
    },
    headCells: {
      style: {
        padding: "0 12px",
        fontFamily: "'Poppins', sans-serif",
      },
    },
    rows: {
      style: {
        minHeight: "58px",
        fontSize: "13px",
        fontFamily: "'Poppins', sans-serif",
        color: "#374151",
        borderBottom: "1px solid #f5f5f5",
        transition: "background .15s ease",
        "&:hover": {
          background: "#f7fafb !important",
        },
      },
    },
    cells: {
      style: {
        padding: "0 12px",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #f0f3f5",
        fontSize: "13px",
        color: "#6b7280",
        fontFamily: "'Poppins', sans-serif",
        minHeight: "52px",
      },
      pageButtonsStyle: {
        borderRadius: "6px",
        height: "32px",
        width: "32px",
        padding: "4px",
        cursor: "pointer",
        transition: "all .2s",
        fill: "#6b7280",
        "&:hover:not(:disabled)": {
          background: "rgba(0,136,156,0.08)",
          fill: "#00889c",
        },
        "&:disabled": {
          opacity: 0.4,
          cursor: "not-allowed",
        },
      },
    },
    subHeader: {
      style: {
        padding: "16px 16px 12px",
        background: "transparent",
      },
    },
  };

  const deleteMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/car/delete",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        getAllMyCar();
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const editMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/edit/mycar",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        if (response?.data?.data?.status === 1) {
          navigate("/dealer/edit-cars", { state: { data: response?.data?.data } });
        } else {
          navigate("/dealer/edit-saved/publish/cars", {
            state: { data: response?.data?.data },
          });
        }
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete Vehicle?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteMyCar(id);
      }
    });
  };

  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container-fluid px-3 px-md-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100 mb-3 gap-2">
            <div>
              <h3 className="cl-page-title">My Listing</h3>
              <p className="cl-page-subtitle">Manage all your listed vehicles</p>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <button type="button" onClick={unpublishMyCars} disabled={loading1 || selectedRowIds.length === 0} className="cl-btn cl-btn-outline cl-btn-sm">
                {loading1 ? <><BtnLoader />Processing...</> : <><i className="fa-solid fa-eye-slash me-1" style={{ fontSize: "11px" }}></i>Unpublish</>}
              </button>
              <button type="button" onClick={publishMyCars} disabled={loading2 || selectedRowIds.length === 0} className="cl-btn cl-btn-primary cl-btn-sm">
                {loading2 ? <><BtnLoader />Processing...</> : <><i className="fa-solid fa-rocket me-1" style={{ fontSize: "11px" }}></i>Publish</>}
              </button>
              <Link to="/dealer/dashboard" className="cl-btn cl-btn-outline cl-btn-sm">Dashboard</Link>
              <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-primary cl-btn-sm"><i className="fa-solid fa-plus"></i>Add Car</Link>
            </div>
          </div>
          {pageLoading ? (
            <SkeletonTable />
          ) : (
            <div className="cl-card" style={{ overflow: "hidden" }}>
              <div className="cl-card-body" style={{ padding: 0 }}>
                {data.length === 0 ? (
                  <div className="cl-empty" style={{ padding: "48px 24px" }}>
                    <div className="cl-empty-icon"><i className="fa-solid fa-car"></i></div>
                    <h6 className="cl-empty-title">No Cars in Store</h6>
                    <p className="cl-empty-text">You haven't added any cars to your inventory yet.</p>
                    <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-primary">
                      <i className="fa-solid fa-plus me-1"></i>Add Your First Car
                    </Link>
                  </div>
                ) : (
                  <DataTable
                    columns={columnsData}
                    data={filteredItems}
                    selectableRows
                    onSelectedRowsChange={handleSelectedRowsChange}
                    pagination
                    paginationPerPage={15}
                    paginationRowsPerPageOptions={[10, 15, 25, 50]}
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 280px)"
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    highlightOnHover
                    pointerOnHover
                    customStyles={tableCustomStyles}
                    noDataComponent={
                      <div style={{ padding: "40px 20px", textAlign: "center", color: "#9ca3af", fontSize: "14px" }}>
                        <i className="fa-solid fa-search" style={{ fontSize: "28px", marginBottom: "12px", display: "block", color: "#d1d5db" }}></i>
                        No vehicles match your search
                      </div>
                    }
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllMyCars;
